var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-modal",
    { attrs: { title: _vm.modalTitle }, on: { close: _vm.dismiss } },
    [
      _c(
        "cms-form",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { "submit-button": "Afsluiten", submitting: _vm.submitting },
          on: { submit: _vm.submit },
        },
        [
          _c("cms-form-radio", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|in:1",
                expression: "'required|in:1'",
              },
            ],
            attrs: {
              bool: "true",
              name: "resolveActionFrequence",
              title: "Meet-/zendfrequentie gecontroleerd",
              "data-vv-as": "Meet-/zendfrequentie gecontroleerd",
              error: _vm.error("resolveActionFrequence"),
            },
            model: {
              value: _vm.frequence,
              callback: function ($$v) {
                _vm.frequence = $$v
              },
              expression: "frequence",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }